import { ButtonGroup, Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { OutlineCustomeButtonGroups, Left, Middle, Right } from "../../../../Constant";
import { Btn } from "../../../../AbstractElements";
import { BUTTON_GROUP } from "../../../../Data/Buttons/ButtonGroup";

const OutlineCustomButtonGroup = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={OutlineCustomeButtonGroups} />
        <CardBody className="btn-group-showcase">
          <Row>
            <Col xl="4" md="6" sm="12">
              <ButtonGroup className="btn-group-pill">
                <Btn outline color="primary">{Left}</Btn>
                <Btn color="primary">{Middle}</Btn>
                <Btn outline color="primary">{Right}</Btn>
              </ButtonGroup>
            </Col>
            {BUTTON_GROUP.map((item, index) => (
              <Col xl="4" md="6" sm="12" key={index}>
                <ButtonGroup className="btn-group-pill">
                  <Btn outline color={item}>{Left}</Btn>
                  <Btn color={item}>{Middle}</Btn>
                  <Btn outline color={item}>{Right}</Btn>
                </ButtonGroup>
              </Col>
            ))}
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default OutlineCustomButtonGroup;
